module.exports = __webpack_public_path__ + "static/shifter-artillerist-63f8b1f02b6e6d73d269c4542480effa.png";